import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { AppsService } from '../apps/apps.service';

@Injectable({
  providedIn: 'root'
})
export class ChargebeeService {

  constructor(private http: HttpClient,
    private appsService: AppsService) { }

  private endpoints = {
    createPortalSession: '/dashboard/selfserve/v1/createportalsession',
    createCheckout: '/dashboard/selfserve/v1/createcheckout',
    cancelCheckout: '/dashboard/selfserve/v1/cancelcheckout'
  };

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  createPortalSession() {
    const endPoint = this.endpoints.createPortalSession;
    const dataToSend = {
      'params': {}
    };
    return this.http.get<any>(endPoint, { ...this.httpOptions, ...dataToSend }).pipe(
      map(this.extractData)
    );
  }

  cancelCheckout() {
    const endPoint = this.endpoints.cancelCheckout;
    const dataToSend = {
      'params': {}
    };
    return this.http.get<any>(endPoint, { ...this.httpOptions, ...dataToSend }).pipe(
      map(this.extractData)
    );
  }


  createCheckout(quantity: number) {
    const endPoint = this.endpoints.createCheckout;
    const dataToSend = {
      'params': {
        qty: quantity.toString()
      }
    };

    return this.http.get<any>(endPoint, { ...this.httpOptions, ...dataToSend }).pipe(
      map(this.extractData)
    );
  }

  getProductionAppsAndSlotsCount(): Observable<any> {
    return this.appsService.getAllApps().pipe(
      map(res => {
        if (res.is_error) {
          return res;
        }
        const companyData = res.api_response.company_details;
        const liveAppList = res.api_response.apps.filter((x) => {
          return x.env === 'production' && x.app_state === 'production';
        });
        return {
          'apps': liveAppList.length,
          'slots': companyData.max_live_app_count
        };
      }),
      catchError(this.handleError<any>('getProductionAppsAndSlotsCount'))
    );
  }


  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure

      // TODO: better job of transforming error for user consumption

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
